import React from "react";
import { useFeatureGate } from "@foundation/statsig";
import WatchlistPageLayoutV1 from "./WatchlistPageLayoutV1";
import WatchlistPageLayoutV2 from "./WatchlistPageLayoutV2";
import { usePageData } from "~context/PageContext";
import type { PortfolioPageData } from "~types/portfolio";

/**
 * A/B Test Wrapper for Watchlist Page Layout
 *
 * Feature Gate: "watchlist_delta"
 * - Control: WatchlistPageLayoutV1 (with PortfolioPageContext)
 * - Variant: WatchlistPageLayoutV2 (with WatchlistContext)
 *
 * To configure in Statsig dashboard:
 * - Create feature gate: "watchlist_delta"
 * - Enable for specific users/conditions
 *
 * Local testing (bypasses Statsig):
 * - Add ?bzcff=WATCHLIST_DELTA to URL to force V2
 */
export default function WatchlistPageLayout() {
  const pageContext = usePageData();
  const statsigEnabled = useFeatureGate("watchlist_delta")?.value ?? false;

  // Check URL override first (?bzcff=WATCHLIST_DELTA), then Statsig
  const urlOverride = (pageContext?.pageData as PortfolioPageData)
    ?.enableWatchlistDelta;
  const showDelta = urlOverride ?? statsigEnabled;

  return showDelta ? <WatchlistPageLayoutV2 /> : <WatchlistPageLayoutV1 />;
}
